import script from "./ResetPasswordModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPasswordModal.vue?vue&type=script&setup=true&lang=js"

import "./ResetPasswordModal.vue?vue&type=style&index=0&id=6c558d6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c558d6f"]])

export default __exports__